import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

import EditButton from "./EditButton";

const ChildrenWithButtons = () => {
  const { children } = useFnrPencilEditInputContext();

  return (
    <FnrHorizontalGap gap={12} inline>
      <div>{children}</div>
      <EditButton />
    </FnrHorizontalGap>
  );
};

export default ChildrenWithButtons;
